module.exports = __webpack_public_path__ + "img/beijing3.ded013fa.jpeg";